import type {State} from 'src/reducers';


export const selectCorporateLabels = (
  state: State,
): {
  [key: string]: string;
} => state.languageSupport.corporateLabels ?? {};
